import { Action } from "@ngrx/store";

export enum CartWidgetsActionTypes {
  GetCartWidgetData = '[STORE PROVIDER] get cart widget data',
  SetCartWidgetData = '[STORE PROVIDER] set cart widget data'
}

export class GetCartWidgetData implements Action {
  readonly type = CartWidgetsActionTypes.GetCartWidgetData;
  constructor() { }
}

export class SetCartWidgetData implements Action {
  readonly type = CartWidgetsActionTypes.SetCartWidgetData;
  constructor(public payload: any) { }
}

export type CartWidgetsActionActions = GetCartWidgetData | SetCartWidgetData;
